import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SharedModule } from '@shared/modules/shared.module';

interface TextSize {
	name: string;
	fontSizeVariable: string;
	lineHeightVariable: string;
	fontSizeValue: string;
	lineHeightValue: string;
	fontSizeValueMobile?: string;
	lineHeightValueMobile?: string;
	category: string;
}

@Component({
	selector: 'app-ui-text-sizes',
	imports: [SharedModule],
	templateUrl: './ui-text-sizes.component.html',
	styleUrl: './ui-text-sizes.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiTextSizesComponent {
	textSizes: TextSize[] = [
		{
			name: 'H1',
			fontSizeVariable: '--h1-font-size',
			lineHeightVariable: '--h1-line-height',
			fontSizeValue: '56px',
			lineHeightValue: '64px',
			fontSizeValueMobile: '48px',
			lineHeightValueMobile: '56px',
			category: 'Headers',
		},
		{
			name: 'H2',
			fontSizeVariable: '--h2-font-size',
			lineHeightVariable: '--h2-line-height',
			fontSizeValue: '48px',
			lineHeightValue: '56px',
			fontSizeValueMobile: '40px',
			lineHeightValueMobile: '48px',
			category: 'Headers',
		},
		{
			name: 'H3',
			fontSizeVariable: '--h3-font-size',
			lineHeightVariable: '--h3-line-height',
			fontSizeValue: '40px',
			lineHeightValue: '48px',
			fontSizeValueMobile: '32px',
			lineHeightValueMobile: '40px',
			category: 'Headers',
		},
		{
			name: 'H4',
			fontSizeVariable: '--h4-font-size',
			lineHeightVariable: '--h4-line-height',
			fontSizeValue: '32px',
			lineHeightValue: '40px',
			fontSizeValueMobile: '24px',
			lineHeightValueMobile: '32px',
			category: 'Headers',
		},
		{
			name: 'H5',
			fontSizeVariable: '--h5-font-size',
			lineHeightVariable: '--h5-line-height',
			fontSizeValue: '24px',
			lineHeightValue: '32px',
			fontSizeValueMobile: '20px',
			lineHeightValueMobile: '24px',
			category: 'Headers',
		},
		{
			name: 'Body XL',
			fontSizeVariable: '--body-xl-font-size',
			lineHeightVariable: '--body-xl-line-height',
			fontSizeValue: '20px',
			lineHeightValue: '24px',
			fontSizeValueMobile: '20px',
			lineHeightValueMobile: '24px',
			category: 'Body',
		},
		{
			name: 'Body L',
			fontSizeVariable: '--body-large-font-size',
			lineHeightVariable: '--body-large-line-height',
			fontSizeValue: '18px',
			lineHeightValue: '24px',
			fontSizeValueMobile: '18px',
			lineHeightValueMobile: '24px',
			category: 'Body',
		},
		{
			name: 'Body M',
			fontSizeVariable: '--body-medium-font-size',
			lineHeightVariable: '--body-medium-line-height',
			fontSizeValue: '16px',
			lineHeightValue: '24px',
			fontSizeValueMobile: '16px',
			lineHeightValueMobile: '24px',
			category: 'Body',
		},
		{
			name: 'Body S',
			fontSizeVariable: '--body-small-font-size',
			lineHeightVariable: '--body-small-line-height',
			fontSizeValue: '14px',
			lineHeightValue: '24px',
			fontSizeValueMobile: '14px',
			lineHeightValueMobile: '24px',
			category: 'Body',
		},
		{
			name: 'Body XS',
			fontSizeVariable: '--body-xsmall-font-size',
			lineHeightVariable: '--body-xsmall-line-height',
			fontSizeValue: '12px',
			lineHeightValue: '16px',
			fontSizeValueMobile: '12px',
			lineHeightValueMobile: '16px',
			category: 'Body',
		},
		{
			name: 'Caption',
			fontSizeVariable: '--caption-font-size',
			lineHeightVariable: '--caption-line-height',
			fontSizeValue: '10px',
			lineHeightValue: '16px',
			fontSizeValueMobile: '10px',
			lineHeightValueMobile: '16px',
			category: 'Caption',
		},
	];

	getTextSizesByCategory(category: string): TextSize[] {
		return this.textSizes.filter((t) => t.category === category);
	}

	categories = ['Headers', 'Body', 'Caption'];

	copyToClipboard(textSize: TextSize): void {
		const textToCopy = `font-size: var(${textSize.fontSizeVariable});\nline-height: var(${textSize.lineHeightVariable});`;

		navigator.clipboard.writeText(textToCopy).then(
			() => {
				// Text copied successfully
			},
			(err) => {
				console.error('Could not copy text: ', err);
			},
		);
	}
}
